import { render, staticRenderFns } from "./consolidationroutedetails.vue?vue&type=template&id=11a95296&"
import script from "./consolidationroutedetails.vue?vue&type=script&lang=js&"
export * from "./consolidationroutedetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports